import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import GridContainer from 'components/Grid/GridContainer';
import { makeStyles } from '@material-ui/core/styles';

//Tabs
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <GridContainer>{children}</GridContainer>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function indexTab(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`
  };
}

const useStyleTabs = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper
  }
}));

export { TabPanel, indexTab, useStyleTabs };
